(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function moneyFallback(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((cents || 0) / 100);
  }

  function asArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      return value.split('|').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    }
    if (typeof value === 'object') return Object.keys(value).map(function (key) {
      return value[key];
    });
    return [];
  }

  function textFrom(value, fallback) {
    if (value == null || value === '') return fallback || '';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (value.title) return String(value.title);
    if (value.name) return String(value.name);
    if (value.question) return String(value.question);
    return fallback || '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  ready(function () {
    document.querySelectorAll('[data-salford-premium-landing="main"]').forEach(function (root) {
      if (root.dataset.splInitialised === 'true') return;
      root.dataset.splInitialised = 'true';

      var dataNode = root.querySelector('[data-salford-product-data]');
      if (!dataNode) return;

      var data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      var products = (data.products || []).concat(data.blockProducts || []).filter(function (product, index, list) {
        return product && product.id && list.findIndex(function (item) {
          return item && String(item.id) === String(product.id);
        }) === index;
      });
      if (!products.length) return;

      var settings = data.settings || {};
      var state = {
        product: products[0],
        variant: null,
        engraving: false,
        gift: false,
        adding: false
      };

      var selectors = {
        select: '[data-spl-product-select]',
        heroImage: '[data-spl-hero-image]',
        title: '[data-spl-title]',
        hook: '[data-spl-hook]',
        rating: '[data-spl-rating]',
        ratingCount: '[data-spl-rating-count]',
        reviewBandText: '[data-spl-review-band-text]',
        badges: '[data-spl-badges]',
        price: '[data-spl-price]',
        flavourHeading: '[data-spl-flavour-heading]',
        descriptor: '[data-spl-descriptor]',
        nose: '[data-spl-nose]',
        palate: '[data-spl-palate]',
        finish: '[data-spl-finish]',
        meters: '[data-spl-meters]',
        recipes: '[data-spl-recipes]',
        faqs: '[data-spl-faqs]',
        engravingToggle: '[data-spl-engraving-toggle]',
        engravingInput: '[data-spl-engraving-input]',
        engravingCount: '[data-spl-engraving-count]',
        giftToggle: '[data-spl-gift-toggle]',
        giftMessage: '[data-spl-gift-message]',
        add: '[data-spl-add]',
        mobileAdd: '[data-spl-mobile-add]',
        mobileSticky: '[data-spl-mobile-sticky]',
        mobileTitle: '[data-spl-mobile-title]',
        mobilePrice: '[data-spl-mobile-price]',
        message: '[data-spl-message]'
      };

      function query(selector) {
        return root.querySelector(selector);
      }

      function queryAll(selector) {
        return Array.prototype.slice.call(root.querySelectorAll(selector));
      }

      function setupStickyVisibility() {
        var sticky = query(selectors.mobileSticky);
        var buyBox = query('.spl-buy-box') || query(selectors.add);
        if (!sticky || !buyBox) return;

        function updateSticky() {
          var rect = buyBox.getBoundingClientRect();
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          var buyBoxVisible = rect.top < viewportHeight && rect.bottom > 0;
          sticky.classList.toggle('is-hidden', buyBoxVisible);
          if (buyBoxVisible) {
            sticky.style.setProperty('display', 'none', 'important');
          } else {
            sticky.style.removeProperty('display');
          }
        }

        updateSticky();
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
      }

      function setText(selector, value) {
        queryAll(selector).forEach(function (element) {
          element.textContent = value;
        });
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
        return moneyFallback(cents);
      }

      function selectedProduct(id) {
        return products.find(function (product) {
          return String(product.id) === String(id);
        }) || products[0];
      }

      function displayPriceForVariant(variant, product) {
        var basePrice = variant ? variant.price : product.price;
        if (state.gift && settings.giftMessageFeeVariantId) {
          basePrice += Number(settings.giftMessageFeePrice || 0);
        }
        return formatMoney(basePrice);
      }

      function variantText(variant) {
        return [
          variant && variant.title,
          variant && variant.option1,
          variant && variant.option2,
          variant && variant.option3
        ].join(' ').toLowerCase();
      }

      function variantForProduct(product) {
        var variants = product.variants || [];
        if (!variants.length) {
          return {
            id: product.variantId,
            available: product.available,
            price: product.price,
            priceFormatted: product.priceFormatted
          };
        }

        if (state.engraving) {
          return variants.find(function (variant) {
            return String(variant.id) === String(product.engravingVariantId);
          }) || variants.find(function (variant) {
            var text = variantText(variant);
            return text.indexOf('engraving') !== -1 && text.indexOf('no engraving') === -1 && text.indexOf('without') === -1;
          }) || variants[0];
        }

        return variants.find(function (variant) {
          return String(variant.id) === String(product.noEngravingVariantId);
        }) || variants.find(function (variant) {
          var text = variantText(variant);
          return text.indexOf('no engraving') !== -1 || text.indexOf('without') !== -1;
        }) || variants[0];
      }

      function productKey(product) {
        return String((product && (product.handle || product.title)) || '').toLowerCase();
      }

      function fallbackProfile(product) {
        var key = productKey(product);
        if (key.indexOf('coffee') !== -1) {
          return {
            rating: '4.9',
            ratingCount: '139',
            heading: 'Bold. Roasted. Velvety.',
            meters: {
              smoothness: 5,
              spice: 2,
              sweetness: 3
            },
            recipes: [
              { title: 'Cold Brew Rum Old Fashioned', description: 'Coffee rum stirred down with bitters and orange oils.' },
              { title: 'Salford Espresso Rumtini', description: 'A rich after-dinner serve with espresso and a silky crema.' },
              { title: 'Coffee & Cola Highball', description: 'Bright cola lift with roasted coffee depth and a lime wedge.' }
            ]
          };
        }

        if (key.indexOf('spiced') !== -1 || key.indexOf('golden') !== -1) {
          return {
            rating: '4.9',
            ratingCount: '507',
            heading: 'Rich. Smooth. Perfectly Spiced.',
            meters: {
              smoothness: 4,
              spice: 4,
              sweetness: 3
            },
            recipes: [
              { title: 'Original Golden Ginger Ale', description: 'Spiced rum lengthened with ginger ale and fresh orange.' },
              { title: 'Spiced & Cola Classic Highball', description: 'A crisp, easy serve with cola, lime and warming spice.' },
              { title: 'Quayside Iced Tea', description: 'A longer cocktail with citrus, tea and Salford spice.' }
            ]
          };
        }

        return {
          rating: '4.9',
          ratingCount: '507',
          heading: 'Balanced. Crafted. Full of Character.',
          meters: {
            smoothness: 4,
            spice: 3,
            sweetness: 3
          },
          recipes: [
            { title: 'Signature Highball', description: 'A simple long serve made for this bottle.' },
            { title: 'Salford Sour', description: 'A bright citrus serve with a smooth finish.' },
            { title: 'Neat Over Ice', description: 'A clean pour to show the spirit at its best.' }
          ]
        };
      }

      function normalizeImageUrl(url) {
        if (!url) return '';
        if (url.indexOf('//') === 0) return window.location.protocol + url;
        return url;
      }

      function firstProductImage(productJson) {
        if (!productJson) return '';
        if (productJson.featured_image) return normalizeImageUrl(productJson.featured_image);
        if (productJson.images && productJson.images.length) return normalizeImageUrl(productJson.images[0]);
        return '';
      }

      function productGalleryImages(productJson) {
        if (!productJson || !productJson.images) return [];
        return productJson.images.map(normalizeImageUrl).filter(Boolean);
      }

      function hydrateProductMedia(product) {
        if (!product || product.mediaHydrated || product.mediaHydrating) {
          return Promise.resolve(product);
        }

        product.mediaHydrating = true;
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var url = product.productJsonUrl || (rootPath.replace(/\/$/, '') + '/products/' + product.handle + '.js');

        return fetch(url, {
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Product media unavailable');
            return response.json();
          })
          .then(function (productJson) {
            var productImage = firstProductImage(productJson);
            var galleryImages = productGalleryImages(productJson);
            if (productImage) {
              product.image = product.image || productImage;
              product.imageAlt = product.imageAlt || product.title;
            }
            if (galleryImages.length) {
              product.galleryImages = galleryImages;
            }

            var ajaxVariants = productJson.variants || [];
            (product.variants || []).forEach(function (variant) {
              var matchingVariant = ajaxVariants.find(function (ajaxVariant) {
                return String(ajaxVariant.id) === String(variant.id);
              });
              if (matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src) {
                variant.image = normalizeImageUrl(matchingVariant.featured_image.src);
                variant.imageAlt = matchingVariant.featured_image.alt || product.title;
              } else if (!variant.image && productImage) {
                variant.image = productImage;
                variant.imageAlt = product.title;
              }
            });

            product.mediaHydrated = true;
            return product;
          })
          .catch(function () {
            product.mediaHydrated = true;
            return product;
          })
          .finally(function () {
            product.mediaHydrating = false;
          });
      }

      function renderBadges(product) {
        var badges = asArray(product.uspBadges);
        var visibleBadges = badges.map(function (badge) {
          return textFrom(badge, '').trim();
        }).filter(Boolean).slice(0, 4);

        function badgeClass(badge) {
          var text = textFrom(badge, '').toLowerCase();
          if (text.indexOf('abv') !== -1 || text.indexOf('%') !== -1) return 'spl-badge spl-badge--abv';
          if (text.indexOf('cl') !== -1 || text.indexOf('ml') !== -1 || text.indexOf('70') !== -1) return 'spl-badge spl-badge--bottle';
          if (text.indexOf('batch') !== -1 || text.indexOf('craft') !== -1 || text.indexOf('hand') !== -1) return 'spl-badge spl-badge--craft';
          if (text.indexOf('fruit') !== -1 || text.indexOf('cherry') !== -1 || text.indexOf('rhubarb') !== -1 || text.indexOf('coffee') !== -1 || text.indexOf('botanical') !== -1) return 'spl-badge spl-badge--flavour';
          if (text.indexOf('gift') !== -1) return 'spl-badge spl-badge--gift';
          return 'spl-badge spl-badge--plain';
        }

        queryAll(selectors.badges).forEach(function (element) {
          element.hidden = !visibleBadges.length;
          element.innerHTML = visibleBadges.map(function (badge) {
            return '<span class="' + badgeClass(badge) + '">' + escapeHtml(textFrom(badge, 'Crafted')) + '</span>';
          }).join('');
        });
      }

      function scoreValue(value, fallback) {
        if (value == null || value === '') return fallback;
        if (typeof value === 'number') return value;

        var text = String(value).toLowerCase();
        var fraction = text.match(/([0-5])\s*\/\s*5/);
        if (fraction) return Number(fraction[1]);

        var numeric = text.match(/[0-5]/);
        if (numeric) return Number(numeric[0]);

        if (text.indexOf('high') !== -1 || text.indexOf('smooth') !== -1 || text.indexOf('sweet') !== -1 || text.indexOf('spicy') !== -1) return 4;
        if (text.indexOf('medium') !== -1 || text.indexOf('balanced') !== -1) return 3;
        if (text.indexOf('low') !== -1 || text.indexOf('dry') !== -1 || text.indexOf('subtle') !== -1) return 2;

        return fallback;
      }

      function meterDots(value, fallback) {
        var score = Math.max(0, Math.min(5, scoreValue(value, fallback)));
        var dots = '';
        for (var index = 1; index <= 5; index += 1) {
          dots += '<i class="' + (index <= score ? 'is-filled' : '') + '"></i>';
        }
        return dots;
      }

      function imageUrlFrom(value) {
        if (!value) return '';
        if (typeof value === 'string') {
          if (/^(https?:)?\/\//.test(value) || value.charAt(0) === '/') return normalizeImageUrl(value);
          return '';
        }
        if (value.src) return normalizeImageUrl(value.src);
        if (value.url) return normalizeImageUrl(value.url);
        if (value.preview_image && value.preview_image.src) return normalizeImageUrl(value.preview_image.src);
        if (value.image) return imageUrlFrom(value.image);
        if (value.featured_image) return imageUrlFrom(value.featured_image);
        if (value.reference) return imageUrlFrom(value.reference);
        return '';
      }

      function renderMeters(product) {
        var fallback = fallbackProfile(product).meters;
        var rows = [
          ['Smoothness', product.smoothnessDry, fallback.smoothness],
          ['Spice', product.spiceCitrus, fallback.spice],
          ['Sweetness', product.sweetnessJuniper, fallback.sweetness]
        ];
        var html = rows.map(function (row) {
          return '<div class="spl-meter"><span>' + escapeHtml(row[0]) + '</span><span>' + meterDots(row[1], row[2]) + '</span></div>';
        }).join('');
        setHtml(selectors.meters, html);
      }

      function stableFallbackReviewCount(product) {
        if (!product || !product.id) return fallbackProfile(product).ratingCount;
        var count = 180 + (Number(String(product.id).slice(-4)) % 420);
        return String(count);
      }

      function ratingDetails(product) {
        var fallback = fallbackProfile(product);
        var key = productKey(product);
        var rating = textFrom(product.rating && product.rating.value ? product.rating.value : product.rating, '');
        var ratingCount = textFrom(product.ratingCount && product.ratingCount.value ? product.ratingCount.value : product.ratingCount, '');

        if (!rating) rating = fallback.rating;
        if (!ratingCount) {
          ratingCount = (key.indexOf('coffee') !== -1 || key.indexOf('spiced') !== -1 || key.indexOf('golden') !== -1)
            ? fallback.ratingCount
            : stableFallbackReviewCount(product);
        }

        return {
          rating: rating,
          ratingCount: ratingCount
        };
      }

      function recipeMarkup(recipe, index, product) {
        var title = textFrom(recipe, ['Original Golden Ginger Ale', 'Spiced & Cola Classic Highball', 'Quayside Iced Tea'][index] || 'Perfect serve');
        var description = recipe && (recipe.description || recipe.method || recipe.summary) ? textFrom(recipe.description || recipe.method || recipe.summary) : 'A Salford serve made for this bottle.';
        var image = recipe && (recipe.image || recipe.featured_image || recipe.photo);
        var galleryImage = product.galleryImages && product.galleryImages[index + 1] ? product.galleryImages[index + 1] : '';
        var img = imageUrlFrom(image) || galleryImage || '';
        return '<article class="spl-recipe ' + (img ? 'spl-recipe--has-image' : 'spl-recipe--no-image') + '">' +
          (img ? '<img src="' + escapeAttribute(img) + '" alt="" loading="lazy">' : '') +
          '<div><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(description) + '</span></div>' +
          '</article>';
      }

      function renderRecipes(product) {
        var recipes = asArray(product.recipes);
        if (!recipes.length) {
          setHtml(selectors.recipes, '');
          queryAll(selectors.recipes).forEach(function (element) {
            element.hidden = true;
          });
          return;
        }
        queryAll(selectors.recipes).forEach(function (element) {
          element.hidden = false;
        });
        setHtml(selectors.recipes, recipes.map(function (recipe, index) {
          return recipeMarkup(recipe, index, product);
        }).join(''));
      }

      function faqMarkup(faq) {
        var question = textFrom(faq, 'How should I serve this rum?');
        var answer = faq && (faq.answer || faq.content || faq.text) ? textFrom(faq.answer || faq.content || faq.text) : 'Serve neat over ice, with premium ginger ale, or in a crafted cocktail.';
        return '<details><summary>' + escapeHtml(question) + '</summary><p>' + escapeHtml(answer) + '</p></details>';
      }

      function renderFaqs(product) {
        var faqs = asArray(product.faqs);
        if (!faqs.length) {
          faqs = [
            { question: 'Can I add engraving?', answer: 'Yes. Select personal engraving and enter one line up to 50 characters.' },
            { question: 'Can I include a gift message?', answer: 'Yes. Add the optional gift card message before adding to basket.' },
            { question: 'When will it arrive?', answer: settings.freeDeliveryText || 'Delivery options are shown at checkout.' }
          ];
        }
        setHtml(selectors.faqs, faqs.slice(0, 5).map(faqMarkup).join(''));
      }

      function setHtml(selector, html) {
        queryAll(selector).forEach(function (element) {
          element.innerHTML = html;
        });
      }

      function setBusy(isBusy) {
        state.adding = isBusy;
        queryAll(selectors.add + ', ' + selectors.mobileAdd).forEach(function (button) {
          if (!button.dataset.originalText) {
            button.dataset.originalText = button.textContent;
          }
          button.disabled = isBusy || !state.variant || !state.variant.available;
          button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
          button.textContent = isBusy ? 'Adding...' : button.dataset.originalText;
        });
      }

      function updateProduct(product) {
        state.product = product;
        state.variant = variantForProduct(product);
        var fallback = fallbackProfile(product);
        var reviews = ratingDetails(product);
        var displayPrice = displayPriceForVariant(state.variant, product);
        var displayImage = state.variant && state.variant.image ? state.variant.image : product.image;
        var displayImageAlt = state.variant && state.variant.imageAlt ? state.variant.imageAlt : product.imageAlt;

        setText(selectors.title, product.title);
        setText(selectors.hook, product.hook || '');
        setText(selectors.rating, reviews.rating);
        setText(selectors.ratingCount, reviews.ratingCount);
        setText(selectors.reviewBandText, reviews.ratingCount + ' reviews · Excellent · ' + reviews.rating);
        setText(selectors.price, displayPrice);
        setText(selectors.mobileTitle, product.title);
        setText(selectors.mobilePrice, displayPrice);
        setText(selectors.flavourHeading, product.flavourHeading || fallback.heading);
        setText(selectors.descriptor, product.descriptor || '');
        setText(selectors.nose, product.nose || '');
        setText(selectors.palate, product.palate || '');
        setText(selectors.finish, product.finish || '');

        var image = query(selectors.heroImage);
        if (image && displayImage) {
          image.src = displayImage;
          image.alt = displayImageAlt || product.title;
          image.hidden = false;
          image.removeAttribute('srcset');
        }

        renderBadges(product);
        renderMeters(product);
        renderRecipes(product);
        renderFaqs(product);
        setBusy(false);

        hydrateProductMedia(product).then(function (hydratedProduct) {
          if (state.product !== hydratedProduct) return;
          var hydratedVariant = variantForProduct(hydratedProduct);
          var hydratedImage = hydratedVariant && hydratedVariant.image ? hydratedVariant.image : hydratedProduct.image;
          var hydratedImageAlt = hydratedVariant && hydratedVariant.imageAlt ? hydratedVariant.imageAlt : hydratedProduct.imageAlt;
          var heroImage = query(selectors.heroImage);
          if (heroImage && hydratedImage) {
            heroImage.src = hydratedImage;
            heroImage.alt = hydratedImageAlt || hydratedProduct.title;
            heroImage.hidden = false;
            heroImage.removeAttribute('srcset');
          }
          renderRecipes(hydratedProduct);
        });
      }

      function lineProperties() {
        var properties = {};
        var engravingInput = query(selectors.engravingInput);

        if (state.engraving && engravingInput && engravingInput.value.trim()) {
          properties['Personal Engraving'] = engravingInput.value.trim().slice(0, 50);
        }

        return properties;
      }

      function addPayload() {
        var giftMessage = query(selectors.giftMessage);
        var giftMessageText = giftMessage && giftMessage.value.trim() ? giftMessage.value.trim() : '';
        var items = [{
          id: state.variant.id,
          quantity: 1,
          properties: lineProperties()
        }];

        if (state.gift && settings.giftMessageFeeVariantId) {
          items.push({
            id: settings.giftMessageFeeVariantId,
            quantity: 1,
            properties: {
              'Add-on for': state.product.title,
              'Gift Message': giftMessageText || 'Gift card message selected'
            }
          });
        }

        return {
          items: items,
          sections: 'cart-drawer,cart-icon-bubble,cart-notification-product,cart-notification-button',
          sections_url: window.location.pathname
        };
      }

      function renderCartFallback(cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;

        var drawerItems = document.querySelector('cart-drawer-items');
        var cartItemsTarget = document.getElementById('CartDrawer-CartItems') || (drawerItems && drawerItems.querySelector('.js-contents'));
        if (!cartItemsTarget) return;

        var rows = cart.items.map(function (item, index) {
          var properties = item.properties || {};
          var propertyMarkup = Object.keys(properties).filter(function (key) {
            return key.charAt(0) !== '_' && properties[key];
          }).map(function (key) {
            return '<div class="product-option"><dt>' + escapeHtml(key) + ':</dt><dd>' + escapeHtml(properties[key]) + '</dd></div>';
          }).join('');
          var image = item.image ? '<td class="cart-item__media"><img class="cart-item__image" src="' + escapeAttribute(item.image) + '" alt="' + escapeAttribute(item.product_title || item.title) + '" loading="lazy" width="150"></td>' : '<td class="cart-item__media"></td>';

          return '<tr id="CartDrawer-Item-' + (index + 1) + '" class="cart-item" role="row">' +
            image +
            '<td class="cart-item__details"><a href="' + escapeAttribute(item.url || '#') + '" class="cart-item__name h4 break">' + escapeHtml(item.product_title || item.title) + '</a><div class="product-option">' + formatMoney(item.original_price) + '</div><dl>' + propertyMarkup + '</dl></td>' +
            '<td class="cart-item__totals right"><div class="cart-item__price-wrapper">' + formatMoney(item.final_line_price) + '</div></td>' +
            '<td class="cart-item__quantity"><div class="quantity cart-quantity"><span aria-hidden="true">Qty: ' + item.quantity + '</span></div></td>' +
          '</tr>';
        }).join('');

        cartItemsTarget.innerHTML = '<div class="drawer__cart-items-wrapper"><table class="cart-items" role="table"><tbody role="rowgroup">' + rows + '</tbody></table></div>';
        if (drawerItems) drawerItems.classList.remove('is-empty');
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.remove('is-empty');
      }

      function refreshCartDrawer(parsedState) {
        var cartDrawer = document.querySelector('cart-drawer');
        var cartNotification = document.querySelector('cart-notification');
        var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: parsedState } }));
        document.dispatchEvent(new CustomEvent('ajaxCart:updated', { bubbles: true, detail: { cart: parsedState } }));

        Promise.all([
          fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' }).then(function (response) {
            return response.ok ? response.text() : '';
          }),
          fetch(rootPath + 'cart.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          }).then(function (response) {
            return response.ok ? response.json() : null;
          }),
          fetch(rootPath + '?sections=cart-icon-bubble', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          }).then(function (response) {
            return response.ok ? response.json() : null;
          })
        ])
          .then(function (results) {
            var drawerHtml = results[0];
            var cartJson = results[1];
            var bubbleSections = results[2];

            if (drawerHtml) {
              var html = new DOMParser().parseFromString(drawerHtml, 'text/html');
              var freshDrawer = html.querySelector('cart-drawer');
              if (freshDrawer && cartDrawer) {
                cartDrawer.innerHTML = freshDrawer.innerHTML;
              } else {
                ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
                  var target = document.querySelector(selector);
                  var source = html.querySelector(selector);
                  if (target && source) target.replaceWith(source);
                });
              }

              if (cartDrawer) cartDrawer.classList.remove('is-empty');
              var drawerItems = document.querySelector('cart-drawer-items');
              if (drawerItems) drawerItems.classList.remove('is-empty');
            }

            if (!document.querySelector('cart-drawer .cart-item')) {
              renderCartFallback(cartJson);
            }

            if (bubbleSections && bubbleSections['cart-icon-bubble']) {
              var parsedBubble = new DOMParser().parseFromString(bubbleSections['cart-icon-bubble'], 'text/html');
              var freshBubble = parsedBubble.querySelector('#shopify-section-cart-icon-bubble') || parsedBubble.getElementById('cart-icon-bubble');
              var liveBubble = document.querySelector('#shopify-section-cart-icon-bubble') || document.getElementById('cart-icon-bubble');
              if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
            }

            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
              cartNotification.renderContents(parsedState);
            }
          })
          .catch(function () {
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          });
      }

      function addToCart(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (!state.product || !state.variant || !state.variant.id || state.adding) return;
        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var engravingInput = query(selectors.engravingInput);

        if (state.engraving && engravingInput && !engravingInput.value.trim()) {
          setText(selectors.message, 'Enter the engraving text before adding to basket.');
          engravingInput.focus();
          return;
        }

        state.adding = true;
        setBusy(true);
        setText(selectors.message, '');

        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(addPayload())
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (error) {
                throw new Error(error.description || 'Unable to add this selection.');
              });
            }
            return response.json();
          })
          .then(function (parsedState) {
            setText(selectors.message, 'Added to basket.');
            refreshCartDrawer(parsedState);
          })
          .catch(function (error) {
            setText(selectors.message, error.message || 'Unable to add this selection.');
          })
          .finally(function () {
            setBusy(false);
          });
      }

      var select = query(selectors.select);
      if (select) {
        select.addEventListener('change', function (event) {
          updateProduct(selectedProduct(event.target.value));
        });
      }

      var engravingToggle = query(selectors.engravingToggle);
      var engravingInput = query(selectors.engravingInput);
      if (engravingToggle && engravingInput) {
        engravingToggle.addEventListener('change', function () {
          state.engraving = engravingToggle.checked;
          engravingInput.disabled = !state.engraving;
          if (state.engraving) engravingInput.focus();
          updateProduct(state.product);
        });
        engravingInput.addEventListener('input', function () {
          engravingInput.value = engravingInput.value.slice(0, 50);
          setText(selectors.engravingCount, String(engravingInput.value.length));
        });
      }

      var giftToggle = query(selectors.giftToggle);
      var giftMessage = query(selectors.giftMessage);
      if (giftToggle && giftMessage) {
        giftToggle.addEventListener('change', function () {
          state.gift = giftToggle.checked;
          giftMessage.disabled = !state.gift;
          if (state.gift) giftMessage.focus();
          updateProduct(state.product);
        });
      }

      queryAll(selectors.add + ', ' + selectors.mobileAdd).forEach(function (button) {
        button.addEventListener('click', addToCart);
      });

      setupStickyVisibility();
      updateProduct(products[0]);
    });
  });
})();
